import React from "react";
import Helmet from "react-helmet";
import Layout from "../components/layout";
import Vimeo from '@u-wave/react-vimeo';
// import Lightbox from 'react-images'

import Gallery from "../components/Gallery";

import full01 from "../assets/images/fulls/Mobile Reg 1.png";
import full02 from "../assets/images/fulls/Mobile Reg 2.png";
import full03 from "../assets/images/fulls/Mobile Reg 3.png";
import full04 from "../assets/images/fulls/Fan Wear Screen.png";
import full05 from "../assets/images/fulls/Fan Wear Screen 2.png";

import thumb01 from "../assets/images/fulls/Mobile Reg 1.png";
import thumb02 from "../assets/images/fulls/Mobile Reg 2.png";
import thumb03 from "../assets/images/fulls/Mobile Reg 3.png";
import thumb04 from "../assets/images/fulls/Fan Wear Screen.png";
import thumb05 from "../assets/images/fulls/Fan Wear Screen 2.png";



const DEFAULT_IMAGES = [
  {
    id: "1",
    source: full01,
    thumbnail: thumb01,
  },
  {
    id: "2",
    source: full02,
    thumbnail: thumb02,
  },
  {
    id: "3",
    source: full03,
    thumbnail: thumb03,
  },
  {
    id: "4",
    source: full04,
    thumbnail: thumb04,
  },
  {
    id: "5",
    source: full05,
    thumbnail: thumb05,
  },
];

const SportsConnect = () => (
  <Layout>
           <Helmet>
          <title>Andy Miller - Sports Connect Marketing Videos</title>
        </Helmet>
        <div id="main">
    <h1>Sports Connect Marketing Videos</h1>
    <p>I handled multiple marketing videos for Sports Connect, frontrunning the whole process. From ideation, to storyboarding, animating, editing, and producing the music to fit the video. Using mainly Adobe After Effects, Adobe Premiere, and Ableton Live Suite 11, these videos have a high level of quality even when I was given a minimal budget.</p>
    
    <Vimeo
  video="366249310"
/>

<br />

<Vimeo
  video="417827111"
/>
    
    <Gallery
              images={DEFAULT_IMAGES.map(
                ({ id, source, thumbnail, caption, description }) => ({
                  source,
                  thumbnail,
                })
              )}
            />
    </div>
  </Layout>
);

export default SportsConnect;
